"use strict";

const CopyText = () => {
    const init = () => {
        $(function() {
            var $copyText = $('.js-copy-text');
            if ($copyText.length > 0) {
                $copyText.on('click', function(e) {
                    e.preventDefault();
                    copyTextToClipboard($(this).data('text'));
                });
            }
        });

        function copyTextToClipboard(text) {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return;
              }
              navigator.clipboard.writeText(text).then(function() {
                $.oc.flashMsg({
                    'text': 'URL copied.',
                    'class': 'success',
                    'interval': 3
                });
              }, function(err) {
                console.error('Async: Could not copy text: ', err);
              });
        }

        function fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            
            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                if(successful){
                    $.oc.flashMsg({
                        'text': 'URL copied.',
                        'class': 'success',
                        'interval': 3
                    });
                }
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }

            document.body.removeChild(textArea);
        }
    };

    return {
        init:init
    };
};

export default CopyText;